/**
 * Print the on-screen MUI delivery note (#doc).
 * Uses the same page styles (Emotion/MUI) — no separate HTML/CSS template.
 */
export async function printMuiDoc({ title } = {}) {
  const el = document.getElementById("doc");
  if (!el) {
    window.alert("Document is not ready to print");
    return;
  }

  const prevTitle = document.title;
  if (title) document.title = title;

  await new Promise((r) => setTimeout(r, 300));

  try {
    window.focus();
    window.print();
  } finally {
    if (title) document.title = prevTitle;
  }
}

export default printMuiDoc;
